import { Button, Modal } from '@lego/connect-components-react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChatWindow } from './chat-window';

export const Assistant = () => {
  const { t } = useTranslation();
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className={`${isOpen && 'max-sm:hidden'}`}>
        <Button
          ref={triggerRef}
          isIconOnly
          iconName="message"
          aria-label={t('assistant.display.launcherLabel')}
          variant="primary"
          onClick={() => setIsOpen(true)}
          className="fixed bottom-400 right-400 z-[50] rounded-full shadow-lg"
        />
      </div>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        triggerRef={triggerRef}
        size="medium"
        scrollBehavior="content"
        closeButtonAriaLabel={t('assistant.action.close')}
        className="max-sm:!pb-0"
      >
        <Modal.Title>{t('assistant.display.title')}</Modal.Title>
        <Modal.Content
          className="flex min-h-0 flex-1 flex-col max-sm:h-full"
          style={{ paddingBottom: 0 }}
        >
          <ChatWindow />
        </Modal.Content>
      </Modal>
    </>
  );
};
